import { render, staticRenderFns } from "./BaseUserForm.vue?vue&type=template&id=4f5876d4&scoped=true"
import script from "./BaseUserForm.vue?vue&type=script&lang=js"
export * from "./BaseUserForm.vue?vue&type=script&lang=js"
import style0 from "./BaseUserForm.vue?vue&type=style&index=0&id=4f5876d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5876d4",
  null
  
)

export default component.exports